import {
    UserProfileView,
    UserProfileViewArgs,
    getUserProfileView,
  } from '../assets/ts/data/user-profile-view'
  import useServerData from './use-server-data'
  
  function useUserProfileViews(fetchArgs?, waitOnParentDependency = false) {
    const {
      data: userProfileView,
      error: userProfileViewError,
      fetchData: fetchUserProfileView,
      isLoading: userProfileViewIsLoading,
    } = useServerData<UserProfileView, UserProfileViewArgs>(
      getUserProfileView,
      fetchArgs,
      waitOnParentDependency
    )
  
    return {
      fetchUserProfileView,
      userProfileView,
      userProfileViewError,
      userProfileViewIsLoading,
    }
  }
  
  export default useUserProfileViews
  